import Extend from 'flarum/common/extenders';
import { extend as extendComponent } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import LinkButton from 'flarum/common/components/LinkButton';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import PostControls from 'flarum/forum/utils/PostControls';
import ModerationPage from './ModerationPage';
import FirstPostApprovalNotification from './FirstPostApprovalNotification';
import DocumentRequestNotification from './DocumentRequestNotification';
export const extend = [new Extend.Routes().add('val-moderation', '/moderation', ModerationPage), new Extend.Notification().add('valFirstPostApproval', FirstPostApprovalNotification).add('valDocumentRequest', DocumentRequestNotification)];
app.initializers.add('val-moderation', () => {
  extendComponent(SessionDropdown.prototype, 'items', function (items) {
    if (app.forum.attribute('valImpersonating')) {
      items.add('val-stop-impersonate', m(Button, {
        icon: 'fas fa-user-shield',
        className: 'Button Button--link',
        onclick: async () => {
          const data = await app.request({
            method: 'POST',
            url: '/val/moderation/users/stop-impersonate'
          });
          window.location.assign(data && data.redirect || '/moderation');
        }
      }, 'Revenir à ma session admin'), 100);
    }
    if (app.forum.attribute('canAccessValModeration')) {
      items.add('val-moderation', m(LinkButton, {
        icon: 'fas fa-shield-alt',
        href: app.route('val-moderation')
      }, 'Modération'), 30);
    }
  });

  // Accès direct depuis le menu « … » d'un message.
  // La permission d'accès à VAL Modération est contrôlée côté serveur
  // sur la page /moderation ; les actions sur les messages conservent
  // en plus leur propre contrôle de permission côté API.
  extendComponent(PostControls, 'moderationControls', function (items, post) {
    if (!app.forum.attribute('canAccessValModeration')) {
      return;
    }
    if (!post || typeof post.contentType !== 'function' || post.contentType() !== 'comment') {
      return;
    }
    const discussion = typeof post.discussion === 'function' ? post.discussion() : null;
    const discussionId = discussion && typeof discussion.id === 'function' ? discussion.id() : null;
    const postId = typeof post.id === 'function' ? post.id() : null;
    if (!discussionId || !postId) {
      return;
    }
    const href = app.route('val-moderation') + '?tab=messages&discussion_id=' + encodeURIComponent(discussionId) + '&post_id=' + encodeURIComponent(postId);
    items.add('val-moderate-post', m(Button, {
      icon: 'fas fa-shield-alt',
      onclick: () => {
        window.location.href = href;
      }
    }, 'Modérer'), 90);
  });
});